import { Typography, Box } from "@mui/material";

import { ClientConfig } from "~/config/clientConfig";
import { clientConfigFieldMetadata } from "~/config/clientConfigFieldMetadata";

import { ConfigFieldRenderer } from "./ConfigFieldRenderer";

interface ConfigSectionPanelProps {
  sectionName: string;
  fields: (keyof ClientConfig)[];
  config: Record<string, unknown>;
  onChange: (key: string, value: unknown) => void;
}

export function ConfigSectionPanel({
  sectionName,
  fields,
  config,
  onChange
}: ConfigSectionPanelProps) {
  // Filter out hidden fields
  const visibleFields = fields.filter(
    (field) => !clientConfigFieldMetadata[field].hidden
  );

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {sectionName}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 3, display: "block" }}
      >
        ({visibleFields.length} fields)
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {visibleFields.map((fieldKey) => {
          const metadata = clientConfigFieldMetadata[fieldKey];
          const value = config[fieldKey as string];

          return (
            <ConfigFieldRenderer
              key={fieldKey as string}
              fieldKey={fieldKey as string}
              metadata={metadata}
              value={value}
              onChange={onChange}
            />
          );
        })}
      </Box>
    </Box>
  );
}
